import { CONTENT_TYPE_LABELS, STATUS_COLORS, type ContentItem } from '../../api/content';

interface ContentCardProps {
  item: ContentItem;
  onClick: () => void;
  compact?: boolean;
}

export function ContentCard({ item, onClick, compact }: ContentCardProps) {
  if (compact) {
    return (
      <button
        onClick={onClick}
        className={`w-full text-left px-1.5 py-0.5 rounded text-[10px] font-medium truncate
          hover:opacity-80 transition-opacity cursor-pointer
          ${STATUS_COLORS[item.status]}`}
        title={item.title}
      >
        {item.title}
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className="w-full bg-white rounded-lg border border-line p-3 text-left
        hover:shadow-md hover:-translate-y-0.5 transition-all cursor-pointer"
    >
      <div className="text-sm font-medium text-text mb-1.5 line-clamp-2">{item.title}</div>
      <div className="flex items-center justify-between">
        <span className="text-[10px] text-subtle">
          {CONTENT_TYPE_LABELS[item.content_type]}
        </span>
        {item.author_name && (
          <span className="text-[10px] text-subtle truncate max-w-[80px]">
            {item.author_name}
          </span>
        )}
      </div>
      {item.planned_publish_date && (
        <div className="text-[10px] text-subtle mt-1">
          {new Date(item.planned_publish_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
        </div>
      )}
      {item.tags.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-2">
          {item.tags.slice(0, 2).map(tag => (
            <span key={tag} className="text-[9px] px-1.5 py-0.5 bg-surface-subtle text-muted rounded">
              {tag}
            </span>
          ))}
        </div>
      )}
    </button>
  );
}
